/**
 * @desc 财务
 */

const termSynopsis = (r) =>
  require.ensure(
    [],
    () => r(require('../views/synopsis/TermSynopsis.vue')),
    'termSynopsis'
  )

/**
 * @desc 日运营汇总
 */

const dailyOperations = (r) =>
  require.ensure(
    [],
    () => r(require('../views/synopsis/DailyOperations.vue')),
    'dailyOperations'
  )
export default [
  //订单
  {
    name: 'termSynopsis',
    path: '/termSynopsis',
    component: termSynopsis,
    meta: { title: '学期总览' },
  },
  {
    name: 'DailyOperations',
    path: '/DailyOperations',
    component: dailyOperations,
    meta: { title: '日运营汇总' },
  },
]
